import { useParams } from 'react-router-dom';
import ILMDLanding from './ILMDLanding';
import NotFoundPage from './NotFoundPage';

const Campaigns = ({ isMobile }) => {
  const { code } = useParams();

  const campaignComponents = {
    ilmd: <ILMDLanding isMobile={isMobile} />,
  };

  return campaignComponents[code] || <NotFoundPage />;
};

export default Campaigns;
